import { render, staticRenderFns } from "./SubstituteTable.vue?vue&type=template&id=424017c6&scoped=true&"
import script from "./SubstituteTable.vue?vue&type=script&lang=js&"
export * from "./SubstituteTable.vue?vue&type=script&lang=js&"
import style0 from "./SubstituteTable.vue?vue&type=style&index=0&id=424017c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424017c6",
  null
  
)

export default component.exports